import {Component, OnDestroy} from '@angular/core';
import * as firebase from 'firebase';
import {Events, MenuController, Platform} from '@ionic/angular';
import {StatusBar} from '@ionic-native/status-bar/ngx';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {UserService} from './services/user.service';
import {ShopService} from './services/shop.service';
import {AuthService} from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnDestroy {
  public appPages = [
    {
      title: 'Home',
      url: '/home',
      icon: 'home'
    }
  ];

  DEFAULT_LANGUAGE = 'pt';

  isAuthenticated = false;
  isSuperAdmin = false;
  hasRestaurant = false;
  shop;
  linkedRestaurantKey;
  user;

  constructor(
    private platform: Platform,
    private statusBar: StatusBar,
    private translateService: TranslateService,
    private appEvents: Events,
    private userService: UserService,
    private shopService: ShopService,
    private authService: AuthService,
    private router: Router,
    private menuController: MenuController
  ) {
    this.initializeApp();
  }

  initializeApp() {

    this.authService.getAuthUser().subscribe(authUser => {
      this.isAuthenticated = !!authUser;
      if (this.isAuthenticated) {
        this.userService.getUserByEmail(authUser.email).then(user => {
          if (user && user.role !== 'client') {
            if (user) {
              this.isAuthenticated = true;
              this.hasRestaurant = !!user.shopId;
              if (this.hasRestaurant) {
                this.shopService.getShop(user.shopId).then(shop => {
                  if (shop) {
                    this.shopService.setCurrentShop(shop.uid);
                  }
                });
              }
            } else {
              this.isAuthenticated = false;
            }
          }
        });
      }
    });
    this.userService.getCurrentUser().subscribe(user => this.user = user);

    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.initTranslate();
    });
  }

  initTranslate() {
    this.translateService.use(this.DEFAULT_LANGUAGE);
  }

  onLoad(page: any) {
    this.router.navigateByUrl(page).then(() => {
      this.menuController.close();
    });
  }

  onLogout() {

    this.authService.signOut();
    this.router.navigateByUrl('/login').then(() => {
      this.menuController.close();
    });
  }

  ngOnDestroy() {
    this.appEvents.unsubscribe('userIsAuthenticated', null);
    this.appEvents.unsubscribe('hasRegisteredRestaurant', null);
  }
}
